import React from 'react';

const PATHS = {
  store: 'M3 10h18M5 10v10h14V10M4 10l1-6h14l1 6M9 14h6',
  star: 'M12 3l2.8 5.7 6.2.9-4.5 4.4 1.1 6.2-5.6-3-5.6 3 1.1-6.2L3 9.6l6.2-.9L12 3z',
  arrowRight: 'M5 12h14M13 6l6 6-6 6',
  box: 'M4 7.5L12 3l8 4.5v9L12 21l-8-4.5v-9zM12 21V12M4 7.5l8 4.5 8-4.5',
  shield: 'M12 3l7 3v5c0 4.6-2.8 8.2-7 10-4.2-1.8-7-5.4-7-10V6l7-3zM9 12l2 2 4-4',
  review: 'M12 3l2.8 5.7 6.2.9-4.5 4.4 1.1 6.2-5.6-3-5.6 3 1.1-6.2L3 9.6l6.2-.9L12 3z',
  location: 'M12 21s7-6.1 7-12a7 7 0 10-14 0c0 5.9 7 12 7 12zM12 11a2.5 2.5 0 100-5 2.5 2.5 0 000 5z',
  phone: 'M7 3h3l1 4-2 1.5a12 12 0 005.5 5.5L16 12l4 1v3c0 1.1-.9 2-2 2C10.3 18 6 13.7 6 8a2 2 0 012-2h1',
  mail: 'M4 5h16v14H4zM4 6l8 6 8-6',
  spinner: 'M12 3a9 9 0 109 9',
  grid: 'M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4zM14 14h6v6h-6z',
  check: 'M5 12l4 4L19 6',
  menu: 'M4 6h16M4 12h16M4 18h16',
  edit: 'M4 20h4L19 9l-4-4L4 16v4zM13 6l4 4',
  trash: 'M5 7h14M9 7V4h6v3M7 7l1 13h8l1-13M10 11v5M14 11v5',
  plus: 'M12 5v14M5 12h14',
};

const LEGACY = {
  'fa-store': 'store',
  'fa-star': 'star',
  'fa-arrow-right': 'arrowRight',
  'fa-box-open': 'box',
  'fa-boxes-stacked': 'box',
  'fa-user-shield': 'shield',
  'fa-clipboard-check': 'check',
  'fa-location-dot': 'location',
  'fa-phone': 'phone',
  'fa-envelope': 'mail',
  'fa-grid-2': 'grid',
  'fa-bars': 'menu',
  'fa-pen': 'edit',
  'fa-trash': 'trash',
  'fa-plus': 'plus',
};

export default function UiIcon({ name, size = 18, strokeWidth = 1.8, className = '', title }) {
  if (!name) return null;
  const raw = String(name).replace(/^fa-solid\s+/, '').trim();
  const key = LEGACY[raw] || raw;
  const path = PATHS[key];
  if (!path) return null;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden={title ? undefined : true}
      aria-label={title}
      role={title ? 'img' : undefined}
    >
      <path d={path} />
    </svg>
  );
}
